import type { ReactElement } from 'react';
import { ActivityFeedModelType } from '../../../server/types/customer-activity-feed-types.ts';
import type { TaskCompletedSource } from '../../analytics/types/analytics-events.ts';
import type { VisitLoggedEntry } from '../lib/order-visit-logged.ts';
import { toQuoteOrderItemPayload } from '../lib/to-quote-order-item-payload.ts';
import { ActivityFeedInsightOutcomeItem } from './activity-feed-insight-outcome-item.tsx';
import { ActivityFeedQuoteOrderItem } from './activity-feed-quote-order-item.tsx';
import { ActivityFeedTaskItem } from './activity-feed-task-item.tsx';

type Props = {
    entry: VisitLoggedEntry;
    source: TaskCompletedSource;
};

/** One quote, task, or insight outcome logged on a visit, as its regular card. */
export function VisitLoggedItem({ entry, source }: Props): ReactElement {
    switch (entry.type) {
        case 'quote':
            return (
                <ActivityFeedQuoteOrderItem
                    payload={toQuoteOrderItemPayload(entry.quote)}
                    modelType={ActivityFeedModelType.QUOTE}
                />
            );
        case 'task':
            return <ActivityFeedTaskItem payload={entry.task} source={source} />;
        case 'outcome':
            return <ActivityFeedInsightOutcomeItem payload={entry.outcome} />;
    }
}
